import React, { ReactNode } from 'react';
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  description,
  actions
}: PageHeaderProps) {
  return <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-1155" data-mp="kr6p5kqnbzz7">
      <div data-id="element-1156" data-mp="psm919h380g0">
        {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.18em] text-azure" data-id="element-1157" data-mp="pprq5mdq2nop">{eyebrow}</p>}
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-navy md:text-[28px]" data-id="element-1158" data-mp="tt69on0vdm6w">{title}</h1>
        {description && <p className="mt-1.5 text-sm text-muted" data-id="element-1159" data-mp="13j99p76es0eq">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-1160" data-mp="13llojbgvdunk">{actions}</div>}
    </div>;
}